import { configureStore } from "@reduxjs/toolkit";
import { IsLoginReducer, UserReducer } from "./Reducers";

const Store = configureStore({
	reducer: {
		user: UserReducer,
		isLogin: IsLoginReducer,
	},
});

export default Store;
